import { Record, Union } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { NewCourse, UpdateCourse, Course as Course_1, S3UploadFile, NewTask_$reflection, Task_$reflection, NewTask, Course_$reflection } from "../Shared/SharedModels.jsx";
import { record_type, bool_type, class_type, option_type, array_type, string_type, union_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { toArray, orElse, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { DialogSurface, Dialog as Dialog_1, Spinner, Text as Text$, Option, Dropdown, Textarea, DialogContent, Title3, DialogTitle, DialogBody as DialogBody_1, Checkbox, Field, Input, Caption2, CardHeader, Card, Button, Image, Caption1, tokens, Caption1Strong } from "@fluentui/react-components";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tap, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Browser_Types_File__File_ReadAsByteArray } from "../fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { useCtx, ContextMsg } from "../Context.jsx";
import { toastServerError, Course } from "../ApiClient.jsx";
import { take, length, iterate, toArray as toArray_1, map as map_1, tryHead, empty, append, singleton, delay, toList, exists } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { AddRegular, ClipboardTaskAddRegular, CheckmarkCircleRegular, CheckmarkLockRegular, DismissRegular, ImageEditRegular, ImageAddRegular } from "@fluentui/react-icons";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { tryFind, append as append_1, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";

export class CourseDialogMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Create", "Edit"];
    }
}

export function CourseDialogMode_$reflection() {
    return union_type("Course.CourseDialog.CourseDialogMode", [], CourseDialogMode, () => [[], [["Item", Course_$reflection()]]]);
}

export class CourseChange extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Added", "Updated"];
    }
}

export function CourseChange_$reflection() {
    return union_type("Course.CourseDialog.CourseChange", [], CourseChange, () => [[["Item", Course_$reflection()]], [["Item", Course_$reflection()]]]);
}

const defaultCreateTask = new NewTask("Oppmøte", "Må møte opp på kurset", true);

class Draft extends Record {
    constructor(Name, Summary, Description, CurrentTasks, NewTasks, ExistingImageUrl, ImageFile, ImagePreview, AddTask, IsSending, NameTouched, SummaryTouched) {
        super();
        this.Name = Name;
        this.Summary = Summary;
        this.Description = Description;
        this.CurrentTasks = CurrentTasks;
        this.NewTasks = NewTasks;
        this.ExistingImageUrl = ExistingImageUrl;
        this.ImageFile = ImageFile;
        this.ImagePreview = ImagePreview;
        this.AddTask = AddTask;
        this.IsSending = IsSending;
        this.NameTouched = NameTouched;
        this.SummaryTouched = SummaryTouched;
    }
}

function Draft_$reflection() {
    return record_type("Course.CourseDialog.Draft", [], Draft, () => [["Name", string_type], ["Summary", string_type], ["Description", string_type], ["CurrentTasks", array_type(Task_$reflection())], ["NewTasks", array_type(NewTask_$reflection())], ["ExistingImageUrl", option_type(string_type)], ["ImageFile", option_type(class_type("Browser.Types.File"))], ["ImagePreview", option_type(string_type)], ["AddTask", option_type(NewTask_$reflection())], ["IsSending", bool_type], ["NameTouched", bool_type], ["SummaryTouched", bool_type]]);
}

const emptyDraft = new Draft("", "", "", [], [], undefined, undefined, undefined, undefined, false, false, false);

function draftFromMode(mode) {
    if (mode.tag === 1) {
        const course = mode.fields[0];
        return new Draft(course.Name, course.Summary, defaultArg(course.Description, ""), course.Tasks, emptyDraft.NewTasks, orElse(course.ThumbnailUrl, course.ImageUrl), emptyDraft.ImageFile, emptyDraft.ImagePreview, emptyDraft.AddTask, emptyDraft.IsSending, emptyDraft.NameTouched, emptyDraft.SummaryTouched);
    }
    else {
        return emptyDraft;
    }
}

function SectionEyebrow(sectionEyebrowInputProps) {
    const label = sectionEyebrowInputProps.label;
    const el = Caption1Strong;
    return createElement(el, {
        style: {
            display: "block",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            color: tokens.colorNeutralForeground3,
            marginTop: 4,
        },
        children: label,
    });
}

function modePill(label) {
    return createElement("span", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            padding: ((2 + "px") + " ") + (10 + "px"),
            borderRadius: 12 + "px",
            color: tokens.colorBrandForeground1,
            backgroundColor: tokens.colorBrandBackground2,
            fontSize: 12 + "px",
            fontWeight: 600,
        },
        children: reactApi.Children.toArray([label]),
    });
}

function uploadProfilePicture(file) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        if (file != null) {
            const f = file;
            return startAsPromise(Browser_Types_File__File_ReadAsByteArray(f)).then((_arg) => {
                let res;
                const MimeType = f.type;
                res = (new S3UploadFile(f.name, MimeType, _arg));
                return Promise.resolve(res);
            });
        }
        else {
            return Promise.resolve(undefined);
        }
    }));
}

function addCourse(newCourse, onChange, setIsSending, setCtx) {
    const pr = tap((res) => {
        let tupledArg;
        if (res.tag === 1) {
            if (res.fields[0].tag === 1) {
                errorToast(setCtx, "addCourseUploadImage", "Kunne ikke opprette kurs", "Kunne ikke behandle bildet", undefined);
                setIsSending(false);
            }
            else {
                errorToast(setCtx, "addCourseConflict", "Kunne ikke opprette kurs", "Det fins kurs med samme navn", undefined);
                setIsSending(false);
            }
        }
        else {
            const c = res.fields[0];
            successToast(setCtx, `addCourse${c.Id}Success`, "Kurs opprettet", `Kurs ${c.Name} ble opprettet`);
            setCtx((tupledArg = [c.Id, c.Name], new ContextMsg(9, [tupledArg[0], tupledArg[1]])));
            onChange(new CourseChange(0, [c]));
        }
    }, startAsPromise(Course.AddCourse(newCourse)));
    void (pr.catch((ex) => {
        setIsSending(false);
        toastServerError(setCtx, ex);
    }));
}

function updateCourse(payload, onChange, setIsSending, setCtx) {
    const pr = tap((res) => {
        let tupledArg;
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 0: {
                    setIsSending(false);
                    errorToast(setCtx, "updateCourseNotFound", "Kunne ikke oppdatere kurs", "Fant ikke kurs", undefined);
                    break;
                }
                case 2: {
                    setIsSending(false);
                    errorToast(setCtx, "updateCourseImageUploadFailed", "Kunne ikke oppdatere kurs", "Bildeopplasting feilet, prøv igjen uten bilde", undefined);
                    break;
                }
                case 1: {
                    setIsSending(false);
                    errorToast(setCtx, "updateCourseValidationFailed", "Kunne ikke oppdatere kurs", "Felter kan ikke være tomme", undefined);
                    break;
                }
                default: {
                    setIsSending(false);
                    errorToast(setCtx, "updateCourseConflict", "Kunne ikke oppdatere kurs", "Det finnes kurs med samme navn", undefined);
                }
            }
        }
        else {
            const updated = res.fields[0];
            successToast(setCtx, `updateCourse${updated.Id}Success`, "Kurs oppdatert", `Kurs ${updated.Name} oppdatert`);
            setCtx((tupledArg = [updated.Id, updated.Name], new ContextMsg(9, [tupledArg[0], tupledArg[1]])));
            onChange(new CourseChange(1, [updated]));
        }
    }, startAsPromise(Course.UpdateCourse(payload)));
    void (pr.catch((ex) => {
        setIsSending(false);
        toastServerError(setCtx, ex);
    }));
}

function addCourseTask(courseId, taskId, callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 1) {
                errorToast(setCtx, "addCourseTaskConflict", "Kunne ikke legge til oppgave", "Oppgave eksisterer allerede på kurs", undefined);
            }
            else {
                errorToast(setCtx, "addCourseTaskNotFound", "Kunne ikke legge til oppgave", "Fant ikke kurs eller oppgave", undefined);
            }
        }
        else {
            const t = res.fields[0];
            callback(t);
            successToast(setCtx, `addCourseTask${t.Id}Success`, "Oppgave lagt til", `Oppgave ${t.Name} ble lagt til`);
        }
    }, startAsPromise(Course.AddCourseTask(courseId, taskId)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function addNewCourseTask(courseId, newTask, callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 0) {
                errorToast(setCtx, "addNewCourseTaskNotFound", "Kunne ikke legge til oppgave", "Fant ikke kurs", undefined);
            }
            else {
                errorToast(setCtx, "addNewCourseTaskConflict", "Kunne ikke legge til oppgave", "Det finnes allerede oppgaver med dette navnet", undefined);
            }
        }
        else {
            const t = res.fields[0];
            callback(t);
            successToast(setCtx, `addNewCourseTask${t.Id}Success`, "Oppgave lagt til", `Oppgave ${t.Name} ble lagt til`);
        }
    }, startAsPromise(Course.AddNewCourseTask(courseId, newTask)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function deleteCourseTask(courseId, taskId, callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, "deleteCourseTaskNotFound", "Kunne ikke fjerne oppgave", "Fant ikke kurs eller oppgave", undefined);
        }
        else {
            const t = res.fields[0];
            callback(t);
            successToast(setCtx, `deleteCourseTask${t.Id}Success`, "Oppgave fjernet", `Oppgave ${t.Name} ble fjernet`);
        }
    }, startAsPromise(Course.DeleteCourseTask(courseId, taskId)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

const fileInputId = "course-dialog-image-input";

function Hero(heroInputProps) {
    let u_1, elems_2;
    const setDraft = heroInputProps.setDraft;
    const draft = heroInputProps.draft;
    const openPicker = () => {
        document.getElementById(fileInputId).click();
    };
    const showingPreview = (draft.ImageFile != null) ? true : ((draft.ExistingImageUrl != null) && (((draft.ImagePreview != null) ? true : (draft.ImageFile != null)) ? true : exists((u) => (u.length > 0), toArray(draft.ExistingImageUrl))));
    let previewSrc;
    const matchValue = draft.ImagePreview;
    const matchValue_1 = draft.ExistingImageUrl;
    let matchResult, p, u_2;
    if (matchValue == null) {
        if (matchValue_1 != null) {
            if ((u_1 = matchValue_1, u_1.length > 0)) {
                matchResult = 1;
                u_2 = matchValue_1;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 0;
        p = matchValue;
    }
    switch (matchResult) {
        case 0: {
            previewSrc = p;
            break;
        }
        case 1: {
            previewSrc = u_2;
            break;
        }
        default:
            previewSrc = undefined;
    }
    return createElement("div", createObj(ofArray([["style", {
        position: "relative",
        width: 100 + "%",
        height: 180,
        flexShrink: 0,
        backgroundColor: tokens.colorNeutralBackground3,
        cursor: "pointer",
    }], ["onClick", (_arg) => {
        openPicker();
    }], (elems_2 = toList(delay(() => {
        let elems_1, el_10, el_12, el;
        if (previewSrc == null) {
            return singleton(createElement("div", createObj(ofArray([["style", {
                height: 100 + "%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 6 + "px ",
                borderStyle: "dashed",
                borderColor: tokens.colorBrandBackgroundStatic,
                borderWidth: 1,
            }], (elems_1 = [(el_10 = ImageAddRegular, createElement(el_10, {
                fontSize: 48,
                primaryFill: tokens.colorBrandForeground2,
            })), (el_12 = Caption1, createElement(el_12, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: "Klikk for å laste opp bilde",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }
        else {
            const src = previewSrc;
            return append(singleton((el = Image, createElement(el, {
                style: {
                    display: "block",
                    width: 100 + "%",
                    height: 180,
                    objectFit: "cover",
                },
                src: src,
                fit: "cover",
            }))), delay(() => {
                let elems, el_4, el_2, el_8, el_6;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    gap: 6 + "px ",
                }], (elems = [(el_4 = Button, createElement(el_4, {
                    size: "small",
                    appearance: "secondary",
                    icon: (el_2 = ImageEditRegular, createElement(el_2, {})),
                    children: "Endre",
                    onClick: (e) => {
                        e.stopPropagation();
                        openPicker();
                    },
                })), (el_8 = Button, createElement(el_8, {
                    size: "small",
                    appearance: "secondary",
                    icon: (el_6 = DismissRegular, createElement(el_6, {})),
                    children: "Slett",
                    onClick: (e_1) => {
                        e_1.stopPropagation();
                        setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks, undefined, undefined, undefined, draft.AddTask, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                    },
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function TaskCard(taskCardInputProps) {
    let elems, el_12, el, el_2, el_4, el_6, el_10, el_8;
    const onRemove = taskCardInputProps.onRemove;
    const canRemove = taskCardInputProps.canRemove;
    const task = taskCardInputProps.task;
    const el_14 = Card;
    return createElement(el_14, createObj(ofArray([["size", "small"], ["appearance", "filled-alternative"], (elems = [(el_12 = CardHeader, createElement(el_12, {
        header: (el = Caption1, createElement(el, {
            children: task.Name,
        })),
        description: (el_2 = Caption2, createElement(el_2, {
            children: task.Description,
        })),
        image: task.VerificationRequired ? ((el_4 = CheckmarkLockRegular, createElement(el_4, {
            fontSize: 20,
            primaryFill: tokens.colorStatusSuccessForeground1,
        }))) : ((el_6 = CheckmarkCircleRegular, createElement(el_6, {
            fontSize: 20,
            primaryFill: tokens.colorStatusSuccessForeground1,
        }))),
        action: (el_10 = Button, createElement(el_10, {
            onClick: (_arg) => {
                onRemove();
            },
            disabled: !canRemove,
            appearance: "transparent",
            style: {
                padding: 0,
                borderWidth: 0,
            },
            icon: (el_8 = DismissRegular, createElement(el_8, {
                style: {
                    padding: 0,
                },
                fontSize: 16,
            })),
        })),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

function NewTaskCardCreateMode(newTaskCardCreateModeInputProps) {
    let elems, el_12, el, el_2, el_4, el_6, el_10, el_8;
    const onRemove = newTaskCardCreateModeInputProps.onRemove;
    const task = newTaskCardCreateModeInputProps.task;
    const el_14 = Card;
    return createElement(el_14, createObj(ofArray([["size", "small"], ["appearance", "filled-alternative"], (elems = [(el_12 = CardHeader, createElement(el_12, {
        header: (el = Caption1, createElement(el, {
            children: task.Name,
        })),
        description: (el_2 = Caption2, createElement(el_2, {
            children: task.Description,
        })),
        image: task.VerificationRequired ? ((el_4 = CheckmarkLockRegular, createElement(el_4, {
            fontSize: 20,
            primaryFill: tokens.colorStatusSuccessForeground1,
        }))) : ((el_6 = CheckmarkCircleRegular, createElement(el_6, {
            fontSize: 20,
            primaryFill: tokens.colorStatusSuccessForeground1,
        }))),
        action: (el_10 = Button, createElement(el_10, {
            onClick: (_arg) => {
                onRemove();
            },
            appearance: "transparent",
            style: {
                padding: 0,
                borderWidth: 0,
            },
            icon: (el_8 = DismissRegular, createElement(el_8, {
                style: {
                    padding: 0,
                },
                fontSize: 16,
            })),
        })),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

function AddTaskEditor(addTaskEditorInputProps) {
    let elems_5, el_25, elems_4, el_23, elems_2, elems, el, el_2, el_9, el_11, el_13, elems_3, el_17, el_15, el_21, el_19;
    const onConfirm = addTaskEditorInputProps.onConfirm;
    const onCancel = addTaskEditorInputProps.onCancel;
    const setTask = addTaskEditorInputProps.setTask;
    const existingNames = addTaskEditorInputProps.existingNames;
    const task = addTaskEditorInputProps.task;
    const nameLower = task.Name.toLocaleLowerCase();
    const nameTaken = exists((n) => (n.toLocaleLowerCase() === nameLower), existingNames);
    const canConfirm = (!isNullOrWhiteSpace(task.Name) && !isNullOrWhiteSpace(task.Description)) && !nameTaken;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 5 + "px ",
    }], (elems_5 = [(el_25 = Card, createElement(el_25, createObj(ofArray([["style", {
        flexGrow: 1,
    }], ["size", "small"], ["appearance", "filled-alternative"], (elems_4 = [(el_23 = CardHeader, createElement(el_23, {
        header: createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexGrow: 1,
            gap: 5 + "px ",
        }], (elems = [(el = Input, createElement(el, {
            placeholder: "Navn",
            value: task.Name,
            onChange: (_arg, value_1_3) => {
                setTask(new NewTask(value_1_3.value, task.Description, task.VerificationRequired));
            },
            size: "medium",
            appearance: "filled-darker",
        })), (el_2 = Input, createElement(el_2, {
            style: {
                display: "flex",
                flexGrow: 1,
            },
            size: "medium",
            appearance: "filled-darker",
            placeholder: "Beskrivelse",
            value: task.Description,
            onChange: (_arg_1, value_1_6) => {
                setTask(new NewTask(task.Name, value_1_6.value, task.VerificationRequired));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), (el_9 = Field, createElement(el_9, createObj(toList(delay(() => append(nameTaken ? singleton(["validationMessage", "Navn må være unikt"]) : empty(), delay(() => {
            let matchValue, el_6, el_4;
            return singleton(["children", (matchValue = tryHead([(el_6 = Checkbox, createElement(el_6, {
                labelPosition: "after",
                label: (el_4 = Caption2, createElement(el_4, {
                    children: "Godkjennes av kursholder",
                })),
                checked: task.VerificationRequired,
                onChange: (_arg_2, c) => {
                    setTask(new NewTask(task.Name, task.Description, Checkbox_toBool(c)));
                },
            }))]), (matchValue == null) ? defaultOf() : matchValue)]);
        })))))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
        image: task.VerificationRequired ? ((el_11 = CheckmarkLockRegular, createElement(el_11, {
            fontSize: 28,
        }))) : ((el_13 = CheckmarkCircleRegular, createElement(el_13, {
            fontSize: 28,
        }))),
        action: createElement("div", createObj(singleton_1((elems_3 = [(el_17 = Button, createElement(el_17, {
            onClick: (_arg_3) => {
                onCancel();
            },
            appearance: "transparent",
            style: {
                padding: 0,
                borderWidth: 0,
            },
            icon: (el_15 = DismissRegular, createElement(el_15, {
                style: {
                    padding: 0,
                },
                fontSize: 16,
            })),
        })), (el_21 = Button, createElement(el_21, {
            disabled: !canConfirm,
            onClick: (_arg_4) => {
                onConfirm();
            },
            appearance: "transparent",
            icon: (el_19 = ClipboardTaskAddRegular, createElement(el_19, {})),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])))),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function DialogBody(dialogBodyInputProps) {
    let elems_14, el_41, elems_13, el_2, elems_1, elems, el, el_39, elems_12, elems_11, elems_5, el_7, el_12, el_17, elems_10, elems_16, el_43, el_49, elems_15;
    const onChange = dialogBodyInputProps.onChange;
    const onClose = dialogBodyInputProps.onClose;
    const allTasks = dialogBodyInputProps.allTasks;
    const initialMode = dialogBodyInputProps.initialMode;
    const setCtx = useCtx()[1];
    let patternInput_1;
    const initial = draftFromMode(initialMode);
    patternInput_1 = reactApi.useState(initial);
    const setDraft = patternInput_1[1];
    const draft = patternInput_1[0];
    const setIsSending = (b) => {
        setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, draft.AddTask, b, draft.NameTouched, draft.SummaryTouched));
    };
    const modeLabel = (initialMode.tag === 1) ? "Rediger kurs" : "Nytt kurs";
    const isEdit = initialMode.tag === 1;
    const currentCourse = (initialMode.tag === 1) ? initialMode.fields[0] : undefined;
    const summaryLen = draft.Summary.length | 0;
    const descriptionLen = draft.Description.length | 0;
    const canSave = ((((!isNullOrWhiteSpace(draft.Name) && !isNullOrWhiteSpace(draft.Summary)) && (summaryLen <= 200)) && (descriptionLen <= 5000)) && !draft.IsSending) && (draft.AddTask == null);
    const editTaskExistingNames = delay(() => append(map((_arg_2) => _arg_2.Name, draft.CurrentTasks), delay(() => append(map((_arg_3) => _arg_3.Name, draft.NewTasks), delay(() => {
        if (initialMode.tag === 0) {
            return singleton(defaultCreateTask.Name);
        }
        else {
            return empty();
        }
    })))));
    const xs_8 = [createElement("input", {
        id: fileInputId,
        type: "file",
        accept: "image/png, image/jpeg",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                const f = files.item(0);
                const reader = new FileReader();
                reader.onload = ((_arg) => {
                    const matchValue = reader.result;
                    if (typeof matchValue === "string") {
                        const base64 = matchValue;
                        setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, f, base64, draft.AddTask, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                    }
                });
                reader.readAsDataURL(f);
            }
        },
        style: {
            display: "none",
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
        overflowY: "auto",
    }], (elems_14 = [createElement(Hero, {
        draft: draft,
        setDraft: setDraft,
    }), (el_41 = DialogBody_1, createElement(el_41, createObj(ofArray([["style", {
        padding: ((16 + "px ") + 18) + "px",
        gap: 12 + "px ",
    }], (elems_13 = [(el_2 = DialogTitle, createElement(el_2, createObj(singleton_1((elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 8 + "px ",
        flexWrap: "wrap",
    }], (elems = [(el = Title3, createElement(el, {
        children: isNullOrWhiteSpace(draft.Name) ? modeLabel : draft.Name,
    })), modePill(modeLabel)], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))]))))), (el_39 = DialogContent, createElement(el_39, createObj(ofArray([["style", {
        overflow: "visible",
    }], (elems_12 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 18 + "px ",
    }], (elems_11 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 12 + "px ",
    }], (elems_5 = [createElement(SectionEyebrow, {
        label: "Detaljer",
    }), (el_7 = Field, createElement(el_7, createObj(toList(delay(() => append(singleton(["required", true]), delay(() => append(singleton(["label", "Navn"]), delay(() => append((draft.NameTouched && isNullOrWhiteSpace(draft.Name)) ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_8, el_4;
        return singleton(["children", (matchValue_8 = tryHead([(el_4 = Input, createElement(el_4, {
            appearance: "filled-darker",
            type: "text",
            value: draft.Name,
            onChange: (_arg_4, value_1_5) => {
                setDraft(new Draft(value_1_5.value, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, draft.AddTask, draft.IsSending, true, draft.SummaryTouched));
            },
        }))]), (matchValue_8 == null) ? defaultOf() : matchValue_8)]);
    }))))))))))), (el_12 = Field, createElement(el_12, createObj(toList(delay(() => append(singleton(["required", true]), delay(() => append(singleton(["label", "Oppsummering"]), delay(() => append((draft.SummaryTouched && isNullOrWhiteSpace(draft.Summary)) ? append(singleton(["validationMessage", "Oppsummering kan ikke være tom"]), delay(() => singleton(["validationState", "error"]))) : ((summaryLen > 200) ? append(singleton(["validationMessage", `Maks 200 tegn (${summaryLen}/200)`]), delay(() => singleton(["validationState", "error"]))) : append(singleton(["validationMessage", `${summaryLen}/200`]), delay(() => singleton(["validationState", "none"])))), delay(() => {
        let matchValue_9, el_9;
        return singleton(["children", (matchValue_9 = tryHead([(el_9 = Textarea, createElement(el_9, {
            style: {
                minHeight: 80,
            },
            appearance: "filled-darker",
            value: draft.Summary,
            onChange: (_arg_5, value_1_12) => {
                setDraft(new Draft(draft.Name, value_1_12.value, draft.Description, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, draft.AddTask, draft.IsSending, draft.NameTouched, true));
            },
        }))]), (matchValue_9 == null) ? defaultOf() : matchValue_9)]);
    }))))))))))), (el_17 = Field, createElement(el_17, createObj(toList(delay(() => append(singleton(["label", "Beskrivelse"]), delay(() => append((descriptionLen > 5000) ? append(singleton(["validationMessage", `Maks 5000 tegn (${descriptionLen}/5000)`]), delay(() => singleton(["validationState", "error"]))) : append(singleton(["validationMessage", `${descriptionLen}/5000`]), delay(() => singleton(["validationState", "none"]))), delay(() => {
        let matchValue_10, el_14;
        return singleton(["children", (matchValue_10 = tryHead([(el_14 = Textarea, createElement(el_14, {
            style: {
                minHeight: 120,
            },
            resize: "vertical",
            appearance: "filled-darker",
            value: draft.Description,
            onChange: (_arg_6, value_1_17) => {
                setDraft(new Draft(draft.Name, draft.Summary, value_1_17.value, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, draft.AddTask, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
            },
        }))]), (matchValue_10 == null) ? defaultOf() : matchValue_10)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 8 + "px ",
        paddingTop: 14,
        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
    }], (elems_10 = toList(delay(() => append(singleton(createElement(SectionEyebrow, {
        label: "Oppgaver",
    })), delay(() => {
        let matchValue_11, course, el_27, elems_6, el_25, el_19, el_21, el_23;
        return append((matchValue_11 = initialMode, (matchValue_11.tag === 1) ? ((course = matchValue_11.fields[0], map_1((task_1) => createElement(TaskCard, {
            task: task_1,
            canRemove: draft.CurrentTasks.length > 1,
            onRemove: () => {
                deleteCourseTask(course.Id, task_1.Id, (removed) => {
                    const newTasks = draft.CurrentTasks.filter((t_1) => (t_1.Id !== removed.Id));
                    setDraft(new Draft(draft.Name, draft.Summary, draft.Description, newTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, draft.AddTask, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                    onChange(new CourseChange(1, [new Course_1(course.Id, course.Name, course.Summary, course.Description, course.ImageUrl, course.ThumbnailUrl, course.Inserted, newTasks)]));
                }, setCtx);
            },
        }), draft.CurrentTasks))) : append(singleton((el_27 = Card, createElement(el_27, createObj(ofArray([["size", "small"], ["appearance", "filled-alternative"], (elems_6 = [(el_25 = CardHeader, createElement(el_25, {
            header: (el_19 = Caption1, createElement(el_19, {
                children: defaultCreateTask.Name,
            })),
            description: (el_21 = Caption2, createElement(el_21, {
                children: defaultCreateTask.Description,
            })),
            image: (el_23 = CheckmarkLockRegular, createElement(el_23, {
                fontSize: 20,
                primaryFill: tokens.colorStatusSuccessForeground1,
            })),
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))), delay(() => map_1((task) => createElement(NewTaskCardCreateMode, {
            task: task,
            onRemove: () => {
                setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks.filter((t) => (t.Name !== task.Name)), draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, draft.AddTask, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
            },
        }), draft.NewTasks)))), delay(() => {
            let elems_9;
            const matchValue_12 = draft.AddTask;
            if (matchValue_12 != null) {
                const pending = matchValue_12;
                return singleton(createElement(AddTaskEditor, {
                    task: pending,
                    existingNames: editTaskExistingNames,
                    setTask: (updated) => {
                        setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, updated, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                    },
                    onCancel: () => {
                        setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, undefined, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                    },
                    onConfirm: () => {
                        if (initialMode.tag === 1) {
                            const course_2 = initialMode.fields[0];
                            addNewCourseTask(course_2.Id, pending, (newTask_1) => {
                                const newTasks_2 = append_1([newTask_1], draft.CurrentTasks);
                                setDraft(new Draft(draft.Name, draft.Summary, draft.Description, newTasks_2, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, undefined, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                                onChange(new CourseChange(1, [new Course_1(course_2.Id, course_2.Name, course_2.Summary, course_2.Description, course_2.ImageUrl, course_2.ThumbnailUrl, course_2.Inserted, newTasks_2)]));
                            }, setCtx);
                        }
                        else {
                            setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, append_1([pending], draft.NewTasks), draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, undefined, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                        }
                    },
                }));
            }
            else {
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 8 + "px ",
                    flexWrap: "wrap",
                }], (elems_9 = toList(delay(() => {
                    let el_31, el_29;
                    return append(singleton((el_31 = Button, createElement(el_31, {
                        size: "small",
                        appearance: "transparent",
                        children: "Legg til oppgave",
                        icon: (el_29 = AddRegular, createElement(el_29, {})),
                        onClick: (_arg_7) => {
                            setDraft(new Draft(draft.Name, draft.Summary, draft.Description, draft.CurrentTasks, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, new NewTask("", "", false), draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                        },
                    }))), delay(() => {
                        let el_37, elems_8;
                        return isEdit ? singleton((el_37 = Dropdown, createElement(el_37, createObj(ofArray([["appearance", "filled-darker"], ["placeholder", "Eksisterende oppgaver"], ["selectedOptions", toArray_1([])], ["onOptionSelect", (_arg_8, value_1_26) => {
                            const matchValue_13 = value_1_26.optionText;
                            let matchResult, course_1, optText;
                            if (currentCourse != null) {
                                if (matchValue_13 != null) {
                                    matchResult = 0;
                                    course_1 = currentCourse;
                                    optText = matchValue_13;
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0: {
                                    iterate((foundTask) => {
                                        addCourseTask(course_1.Id, foundTask.Id, (newTask) => {
                                            const newTasks_1 = append_1([newTask], draft.CurrentTasks);
                                            setDraft(new Draft(draft.Name, draft.Summary, draft.Description, newTasks_1, draft.NewTasks, draft.ExistingImageUrl, draft.ImageFile, draft.ImagePreview, draft.AddTask, draft.IsSending, draft.NameTouched, draft.SummaryTouched));
                                            onChange(new CourseChange(1, [new Course_1(course_1.Id, course_1.Name, course_1.Summary, course_1.Description, course_1.ImageUrl, course_1.ThumbnailUrl, course_1.Inserted, newTasks_1)]));
                                        }, setCtx);
                                    }, toArray(tryFind((t_2) => (t_2.Name === optText), allTasks)));
                                    break;
                                }
                                case 1: {
                                    break;
                                }
                            }
                        }], (elems_8 = toList(delay(() => map_1((t_3) => {
                            let elems_7, el_33;
                            const el_35 = Option;
                            return createElement(el_35, createObj(ofArray([["disabled", draft.CurrentTasks.some((s) => (s.Id === t_3.Id))], ["value", t_3.Name], ["text", t_3.Name], (elems_7 = [(el_33 = Text$, createElement(el_33, {
                                children: t_3.Name,
                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])));
                        }, allTasks))), ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
            }
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_14))])]))), createElement("div", createObj(ofArray([["style", {
        padding: ((12 + "px ") + 18) + "px",
        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
        backgroundColor: tokens.colorNeutralBackground1,
        display: "flex",
        justifyContent: "flex-end",
        gap: 8 + "px ",
        flexShrink: 0,
    }], (elems_16 = [(el_43 = Button, createElement(el_43, {
        appearance: "secondary",
        children: "Avbryt",
        disabled: draft.IsSending,
        onClick: (_arg_9) => {
            onClose();
        },
    })), (el_49 = Button, createElement(el_49, createObj(ofArray([["appearance", "primary"], ["disabled", !canSave], ["onClick", (_arg_10) => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setIsSending(true);
            return uploadProfilePicture(draft.ImageFile).then((_arg_1) => {
                const imagePayload = _arg_1;
                if (initialMode.tag === 1) {
                    const original = initialMode.fields[0];
                    updateCourse(new UpdateCourse(new Course_1(original.Id, draft.Name, draft.Summary, isNullOrWhiteSpace(draft.Description) ? undefined : draft.Description, (draft.ImageFile == null) ? ((draft.ExistingImageUrl == null) ? undefined : original.ImageUrl) : original.ImageUrl, (draft.ImageFile == null) ? ((draft.ExistingImageUrl == null) ? undefined : original.ThumbnailUrl) : original.ThumbnailUrl, original.Inserted, draft.CurrentTasks), imagePayload), (change_1) => {
                        onChange(change_1);
                        onClose();
                    }, setIsSending, setCtx);
                    return Promise.resolve();
                }
                else {
                    addCourse(new NewCourse(draft.Name, draft.Summary, draft.Description, append_1([defaultCreateTask], draft.NewTasks), imagePayload), (change) => {
                        onChange(change);
                        onClose();
                    }, setIsSending, setCtx);
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }], (elems_15 = toList(delay(() => {
        let el_45, el_47;
        return draft.IsSending ? singleton((el_45 = Spinner, createElement(el_45, {
            size: "tiny",
        }))) : singleton((el_47 = Text$, createElement(el_47, {
            children: (initialMode.tag === 1) ? "Lagre" : "Opprett",
        })));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_15))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))];
    return react.createElement(react.Fragment, {}, ...xs_8);
}

/**
 * Stateless wrapper: opens/closes the FluentUI dialog based on `mode`.
 * When `mode` is `None`, `DialogBody` is unmounted entirely; when it
 * flips back to `Some`, a fresh `DialogBody` mounts and seeds its draft
 * from the new mode. That natural mount/unmount handles state reset —
 * no effects, no manual reinit.
 */
export function Dialog(dialogInputProps) {
    let elems_1, el, elems, elemsToUse;
    const onChange = dialogInputProps.onChange;
    const onClose = dialogInputProps.onClose;
    const allTasks = dialogInputProps.allTasks;
    const mode = dialogInputProps.mode;
    const el_2 = Dialog_1;
    return createElement(el_2, createObj(ofArray([["open", mode != null], ["modalType", "modal"], ["onOpenChange", (_arg, value_1_1) => {
        if (!value_1_1.open) {
            onClose();
        }
    }], (elems_1 = [(el = DialogSurface, createElement(el, createObj(ofArray([["style", {
        maxWidth: 560,
        padding: 0,
        overflow: "hidden",
        maxHeight: 90 + "vh",
        display: "flex",
        flexDirection: "column",
    }], (elems = toList(delay(() => {
        if (mode != null) {
            const m = mode;
            return singleton(createElement(DialogBody, {
                initialMode: m,
                allTasks: allTasks,
                onClose: onClose,
                onChange: onChange,
            }));
        }
        else {
            return singleton(defaultOf());
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], (elemsToUse = ((length(elems_1) <= 2) ? elems_1 : take(2, elems_1)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=CourseDialog.jsx.map
